import { Roles } from '../model/role.interface';

// Always put roles in arrays in their order
export const ENTERPRISE_ROLES = [Roles.enterpriseHR, Roles.enterpriseRM];
export const COMPANY_ROLES = [Roles.companyHR, Roles.companyRM, Roles.recruiter];
export const ALL_ROLES = ENTERPRISE_ROLES.concat(COMPANY_ROLES);
